import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RouteHistoryService {
  private router = inject(Router);

  private readonly LAST_URL_KEY = 'last_url';

  private ignoredRoutes = [
    '/',
    '/login',
    '/signup',
    '/reset-password',
    '/pages/api-documentation',
    '/pages/privacy-policy',
    '/pages/terms-of-service',
  ];

  startTracking(): void {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd =>
            event instanceof NavigationEnd
        )
      )
      .subscribe((event) => {
        const url = event.urlAfterRedirects;

        if (this.shouldIgnore(url)) {
          return;
        }

        localStorage.setItem(this.LAST_URL_KEY, url);
      });
  }

  getLastUrl(): string {
    const lastUrl = localStorage.getItem(this.LAST_URL_KEY);

    if (!lastUrl || this.shouldIgnore(lastUrl)) {
      return '/account/connections';
    }

    return lastUrl;
  }

  clear(): void {
    localStorage.removeItem(this.LAST_URL_KEY);
  }

  private shouldIgnore(url: string): boolean {
    return (
      this.ignoredRoutes.includes(url) ||
      url.startsWith('/loads/view/') ||
      url.startsWith('/trucks/view/')
    );
  }
}